import GroupsIcon from "@mui/icons-material/Groups";
import GroupAddIcon from "@mui/icons-material/GroupAdd";
import EditIcon from "@mui/icons-material/Edit";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import BlockIcon from "@mui/icons-material/Block";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import PeopleIcon from "@mui/icons-material/People";
import SecurityIcon from "@mui/icons-material/Security";
import IconSelector from "../../components/IconSelector";
import ColorSelector from "../../components/ColorSelector";
import CardPreview from "../../components/CardPreview";
import PermissionsTree from "../../components/PermissionsTree";
import PermissoesGrupoShieldIcon from "../../components/PermissoesGrupoShieldIcon";
import { ConfirmDialog } from "../../components/ConfirmDialog";
import listaStyles from "./styles.module.css";
import {
  Box,
  Chip,
  CircularProgress,
  Grid,
  Link as MuiLink,
  Paper,
  Switch,
  TextField,
  Typography,
  Button,
  Stack,
} from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import WorkOutline from "@mui/icons-material/WorkOutline";
import Add from "@mui/icons-material/Add";
import FilterListIcon from "@mui/icons-material/FilterList";
import Tune from "@mui/icons-material/Tune";
import Lock from "@mui/icons-material/Lock";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import AdminPanelSettings from "@mui/icons-material/AdminPanelSettings";
import Person from "@mui/icons-material/Person";
import Diversity3 from "@mui/icons-material/Diversity3";
import { useCallback, useEffect, useMemo, useState } from "react";
import {
  editarGrupoUsuario,
  inserirGrupoUsuario,
  getGrupoDetalhe,
  getPermissoesArvore,
  buscarGruposCatalogo,
  duplicarGrupoUsuario,
  patchGrupoUsuarioStatus,
  buscarNiveisAssociacaoGerenciamento,
  excluirGrupoUsuario,
  validarNomeGrupoGerenciamento,
  previewAlteracaoPermissoesGrupo,
} from "../../services/auth.service";
import MensagemErro from "../../components/MensagemErro";
import MensagemSucesso from "../../components/MensagemSucesso";
import Pagination from "../../components/Pagination";
import WhiteButton from "../../components/WhiteButton";
import BlueButton from "../../components/BlueButton";
import {
  usePermissoes,
  CHAVES_CRIAR_GRUPO,
  CHAVES_EDITAR_GRUPO,
  CHAVES_DUPLICAR_GRUPO,
  CHAVES_ALTERAR_STATUS_GRUPO,
  CHAVES_EXCLUIR_GRUPO,
} from "../../config/Context/PermissoesContext";
import { debounce } from "lodash";
import {
  Groups,
  AccountBalance,
  ReceiptLong,
  Engineering,
  Work,
  Business,
  Settings,
  Assessment,
  Gavel,
  SupportAgent,
  SearchOff,
} from "@mui/icons-material";

const GRUPO_LIST_ICON_MAP = {
  groups: Groups,
  group: Groups,
  account_balance: AccountBalance,
  receipt_long: ReceiptLong,
  engineering: Engineering,
  admin_panel_settings: AdminPanelSettings,
  people: PeopleIcon,
  security: SecurityIcon,
  work: Work,
  business: Business,
  settings: Settings,
  assessment: Assessment,
  gavel: Gavel,
  support_agent: SupportAgent,
};

const COR_ICON_BG = {
  purple: "#ede7f6",
  blue: "#e8f0fe",
  green: "#e6f4ea",
  orange: "#fef7e0",
  teal: "#e0f2f1",
  red: "#fce8e6",
  cyan: "#e0f7fa",
  pink: "#fce4ec",
  indigo: "#e8eaf6",
};

const COR_ICON_FG = {
  purple: "#673ab7",
  blue: "#1a73e8",
  green: "#34a853",
  orange: "#fa7b17",
  teal: "#009688",
  red: "#ea4335",
  cyan: "#00bcd4",
  pink: "#e91e63",
  indigo: "#3f51b5",
};

function mensagemErroApi(error, fallback = "Erro de conexão. Verifique se a API de autenticação está rodando.") {
  const d = error?.response?.data;
  return d?.mensagem || d?.erro || d?.message || error?.message || fallback;
}

/** Persiste nome + texto longo no único campo `descricao` do BD (até 255). */
function buildDescricaoGrupoApi(nome, resumo) {
  const n = String(nome || "").trim();
  const r = String(resumo || "").trim();
  if (!n && !r) return "";
  if (r) return `${n}\n${r}`.slice(0, 255);
  return n.slice(0, 255);
}

function parseDescricaoGrupoApi(text) {
  const s = String(text || "");
  const i = s.indexOf("\n");
  if (i === -1) return { nome: s.trim(), resumo: "" };
  return { nome: s.slice(0, i).trim(), resumo: s.slice(i + 1).trim().slice(0, 255) };
}

function normalizeGrupoIconKey(raw) {
  const k = String(raw || "groups")
    .toLowerCase()
    .replace(/-/g, "_");
  if (k === "group") return "groups";
  return k || "groups";
}

function GrupoListAvatarIcon({ iconKey, sx }) {
  const k = normalizeGrupoIconKey(iconKey);
  const Cmp = GRUPO_LIST_ICON_MAP[k] || Groups;
  return <Cmp sx={sx} />;
}

const NIVEL_CARD_ICONS = [SecurityIcon, AdminPanelSettings, PeopleIcon, GroupsIcon, Person, Diversity3];

function normalizarNivelAssociacaoGrupo(nivel) {
  const ordem = Number(nivel?.ordem);
  const chave = String(nivel?.chave ?? "").trim().toLowerCase();
  const nome = String(nivel?.nome ?? "").trim().toLowerCase();
  if (["admin", "administrador", "gestor"].includes(chave) || ["administrador", "gestor"].includes(nome)) {
    return null;
  }
  if (
    ordem === 6 ||
    chave === "nivel_acesso_comum" ||
    chave === "todos_com_permissao" ||
    chave === "todos-com-permissao" ||
    nome === "nível de acesso comum" ||
    nome === "nivel de acesso comum" ||
    nome === "todos com permissão" ||
    nome === "todos com permissao"
  ) {
    return {
      ...nivel,
      chave: "nivel_acesso_comum",
      nome: "Nível de Acesso Comum",
      descricao: "Usuários com nível de acesso comum",
    };
  }
  if (ordem === 5 || chave === "lider_equipe" || chave === "lider-de-equipe" || nome === "líder de equipe" || nome === "lider de equipe") {
    return {
      ...nivel,
      chave: "financeiro",
      nome: "Financeiro",
      descricao: "Usuários do nível Financeiro",
    };
  }
  if (ordem === 4 || chave === "ti" || chave === "coordenador" || nome === "ti" || nome === "coordenador") {
    return {
      ...nivel,
      chave: "ti",
      nome: "TI",
      descricao: "Usuários do nível TI",
    };
  }
  return nivel;
}

function deduplicarNiveisAssociacao(niveis = []) {
  const porChave = new Map();
  niveis.filter(Boolean).forEach((nivel) => {
    const chave = String(nivel?.chave ?? "").trim().toLowerCase();
    if (!chave || porChave.has(chave)) return;
    porChave.set(chave, nivel);
  });
  return Array.from(porChave.values());
}

function formatarResumoNomesSelecionados(nomes = [], vazio = "Nenhum selecionado") {
  const lista = [...new Set(nomes.map((nome) => String(nome ?? "").trim()).filter(Boolean))];
  if (lista.length === 0) return vazio;
  if (lista.length <= 3) return lista.join(" / ");
  return `${lista.slice(0, 3).join(" / ")} +${lista.length - 3}`;
}

function comVisualizarImplicito(chaves, arvore) {
  const result = new Set(chaves);
  for (const menu of arvore || []) {
    for (const sub of (menu.subcategorias || [])) {
      const permKeys = (sub.permissoes || []).map((p) => p.chave);
      const readKeys = permKeys.filter((k) => { const lk = k.toLowerCase(); return lk.includes("read") || lk.includes("view"); });
      const deleteKeys = permKeys.filter((k) => k.toLowerCase().includes("delete"));
      const editKeys = permKeys.filter((k) => { const lk = k.toLowerCase(); return lk.includes("edit") || lk.includes("update"); });
      const temOutra = permKeys.some((k) => { const lk = k.toLowerCase(); return !(lk.includes("read") || lk.includes("view")) && result.has(k); });
      const temEdit = editKeys.some((k) => result.has(k));
      if (temOutra) readKeys.forEach((k) => result.add(k));
      if (temEdit) deleteKeys.forEach((k) => result.add(k));
    }
  }
  return [...result];
}

const GruposUsuarios = () => {
  const { pode, superAdmin } = usePermissoes();
  const podeDuplicar = pode(["create-roles"]) && pode(["update-roles"]);
  const podeAlterarStatus = pode(CHAVES_ALTERAR_STATUS_GRUPO);
  const podeCriar = pode(CHAVES_CRIAR_GRUPO);
  const podeEditar = pode(CHAVES_EDITAR_GRUPO);
  const podeExcluir = pode(CHAVES_EXCLUIR_GRUPO);
  const podeGerenciarNiveisAssociacao = Boolean(superAdmin);

  /** null = lista; 'new' | 'edit' = formulário em tela cheia (padrão Usuários). */
  const [formGrupo, setFormGrupo] = useState(null);
  const [openConfirmDup, setOpenConfirmDup] = useState(null);
  const [openConfirmStatus, setOpenConfirmStatus] = useState(null);
  const [openConfirmDelete, setOpenConfirmDelete] = useState(null);
  const [openConfirmPreview, setOpenConfirmPreview] = useState(null);
  const [stats, setStats] = useState(null);
  const [grupos, setGrupos] = useState([]);
  const [page, setPage] = useState(1);
  const perPage = 20;
  const [totalPages, setTotalPages] = useState(1);
  const [openSnackbarErro, setOpenSnackbarErro] = useState(false);
  const [openSnackbarSucesso, setOpenSnackbarSucesso] = useState(false);
  const [msg, setMsg] = useState("");
  const [loading, setLoading] = useState(true);
  const [formEditData, setFormEditData] = useState();
  const [optionsFunct, setOptionsFunct] = useState([]);
  const [formNewData, setFormNewData] = useState();
  const [editFunct, setEditFunct] = useState();
  const [newFunct, setNewFunct] = useState();
  const [permissoesArvore, setPermissoesArvore] = useState([]);
  const [permissoesGrupoExpandidas, setPermissoesGrupoExpandidas] = useState(false);
  const [expandirPermissoesGrupoToken, setExpandirPermissoesGrupoToken] = useState(0);
  const [recolherPermissoesGrupoToken, setRecolherPermissoesGrupoToken] = useState(0);

  const [niveisOptions, setNiveisOptions] = useState([]);
  const [totalItems, setTotalItems] = useState(0);

  const loadCatalogo = useCallback(async () => {
    try {
      setLoading(true);
      const res = await buscarGruposCatalogo({ page, per_page: perPage });
      /* api.service retorna já o JSON do backend ({ data, stats, pagination }), não axios response */
      const payload = res && typeof res === "object" && !Array.isArray(res) ? res : {};
      const rows = Array.isArray(payload.data)
        ? payload.data
        : Array.isArray(res)
          ? res
          : [];
      setStats(payload.stats ?? null);
      setGrupos(rows);
      if (payload.pagination) {
        setTotalPages(Math.max(1, payload.pagination.total_pages ?? 1));
        setTotalItems(payload.pagination.total ?? payload.pagination.total_items ?? rows.length);
      }
    } catch (error) {
      setMsg(mensagemErroApi(error));
      setOpenSnackbarErro(true);
    } finally {
      setLoading(false);
    }
  }, [page, perPage]);

  useEffect(() => {
    loadCatalogo();
  }, [loadCatalogo]);

  useEffect(() => {
    const loadNiveis = async () => {
      try {
        const r = await buscarNiveisAssociacaoGerenciamento();
        const itens = r?.data?.itens ?? r?.itens ?? [];
        setNiveisOptions(Array.isArray(itens) ? deduplicarNiveisAssociacao(itens.map(normalizarNivelAssociacaoGrupo)) : []);
      } catch {
        setNiveisOptions([]);
      }
    };
    loadNiveis();
  }, []);

  useEffect(() => {
    const fetchDataAutoComplete = async () => {
      try {
        const res = await getPermissoesArvore();
        const arvore = res?.arvore ?? res?.data?.arvore ?? [];
        setPermissoesArvore(arvore);
        const lista = [];
        (arvore || []).forEach((mod) =>
          (mod.subcategorias || []).forEach((sub) =>
            (sub.permissoes || []).forEach((p) => {
              if (p?.chave) lista.push({ id: p.chave, label: p.descricao || p.chave });
            })
          )
        );
        setOptionsFunct(lista.length > 0 ? lista : []);
      } catch (err) {
        if (err?.response) setMsg(err.response?.data?.mensagem ?? "Erro ao carregar permissões.");
        else setMsg("Erro: Tente novamente!");
        setOpenSnackbarErro(true);
      }
    };
    fetchDataAutoComplete();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // newFunct e editFunct agora são arrays de strings (chaves de permissões)
    const novasFuncionalidades = comVisualizarImplicito(
      (Array.isArray(newFunct)
        ? newFunct.map((chave) => (typeof chave === "string" ? chave : String(chave)))
        : []
      ).filter((chave) => String(chave).trim()),
      permissoesArvore
    );
    const EditFuncionalidades = comVisualizarImplicito(
      (Array.isArray(editFunct)
        ? editFunct.map((chave) => (typeof chave === "string" ? chave : String(chave)))
        : []
      ).filter((chave) => String(chave).trim()),
      permissoesArvore
    );


    try {
      const nomeDigitado = (formNewData ? formNewData?.nomeGrupo : formEditData?.nomeGrupo || "").trim();
      if (nomeDigitado.length < 3 || nomeDigitado.length > 50) {
        setMsg("O nome do grupo deve ter entre 3 e 50 caracteres.");
        setOpenSnackbarErro(true);
        return;
      }
      // RN05: nome único (case-insensitive)
      try {
        const idGrupoValidacao = formNewData ? null : formEditData?.idGrupoUsuario;
        await validarNomeGrupoGerenciamento(nomeDigitado, idGrupoValidacao);
      } catch (errNome) {
        setMsg(errNome?.response?.data?.mensagem ?? "Nome do grupo inválido ou já existe.");
        setOpenSnackbarErro(true);
        return;
      }

      if (formNewData) {
        if (novasFuncionalidades.length === 0) {
          setMsg("Selecione ao menos uma permissão.");
          setOpenSnackbarErro(true);
          return;
        }
      } else if (EditFuncionalidades.length === 0) {
        setMsg("Selecione ao menos uma permissão.");
        setOpenSnackbarErro(true);
        return;
      }

      if (formNewData) {
        const body = {
          grupo: {
            descricao: buildDescricaoGrupoApi(formNewData.nomeGrupo, formNewData.descricaoResumo),
            ativo: formNewData.ativo !== false,
            icone: formNewData.icone || "groups",
            cor: formNewData.cor || "blue",
            idNivelAssociacao:
              formNewData.idNivelAssociacao != null && formNewData.idNivelAssociacao !== ""
                ? Number(formNewData.idNivelAssociacao)
                : null,
          },
          permissoes: novasFuncionalidades,
        };
        const response = await inserirGrupoUsuario(body);
        setMsg(response?.mensagem ?? response?.data?.mensagem ?? "Grupo criado com sucesso.");
        setOpenSnackbarSucesso(true);
      } else {
        const ativoBool = formEditData.ativo === "Sim" || formEditData.ativo === true;
        const body = {
          grupo: {
            descricao: buildDescricaoGrupoApi(formEditData.nomeGrupo, formEditData.descricaoResumo),
            ativo: ativoBool,
            icone: formEditData.icone || "groups",
            cor: formEditData.cor || "blue",
            idNivelAssociacao:
              formEditData.idNivelAssociacao != null && formEditData.idNivelAssociacao !== ""
                ? Number(formEditData.idNivelAssociacao)
                : null,
          },
          permissoes: EditFuncionalidades,
        };
        // CA: ao remover permissões, mostrar preview (usuarios afetados)
        try {
          const prev = await previewAlteracaoPermissoesGrupo(formEditData.idGrupoUsuario, EditFuncionalidades);
          const preview = prev?.data?.preview ?? prev?.preview;
          const removidas = preview?.permissoesRemovidas ?? [];
          const afetados = preview?.usuariosAfetados ?? 0;
          if (Array.isArray(removidas) && removidas.length > 0 && afetados > 0) {
            setOpenConfirmPreview({ idGrupo: formEditData.idGrupoUsuario, body, preview });
            return;
          }
        } catch {
          // se falhar preview, segue salvando
        }

        const responseEditGps = await editarGrupoUsuario(formEditData.idGrupoUsuario, body);
        setMsg(responseEditGps?.mensagem ?? responseEditGps?.data?.mensagem ?? "Grupo atualizado com sucesso.");
        setOpenSnackbarSucesso(true);
      }
      await loadCatalogo();
    } catch (error) {
      console.error('❌ Erro ao salvar:', error);
      setMsg(error?.response?.data?.mensagem ?? "Erro ao salvar.");
      setOpenSnackbarErro(true);
    }

    fecharFormularioGrupo();
  };

  const executarExcluirGrupo = async () => {
    if (!openConfirmDelete?.idGrupo) return;
    try {
      await excluirGrupoUsuario(openConfirmDelete.idGrupo);
      setMsg("Grupo excluído com sucesso.");
      setOpenSnackbarSucesso(true);
      setOpenConfirmDelete(null);
      fecharFormularioGrupo();
      await loadCatalogo();
    } catch (error) {
      const codigo = error?.response?.data?.codigo;
      if (codigo === "GROUP_HAS_USERS") {
        setMsg(error?.response?.data?.mensagem ?? "Não é possível excluir grupo com usuários associados.");
      } else {
        setMsg(mensagemErroApi(error));
      }
      setOpenSnackbarErro(true);
      setOpenConfirmDelete(null);
    }
  };

  const confirmarSalvarComImpacto = async () => {
    if (!openConfirmPreview?.idGrupo || !openConfirmPreview?.body) return;
    try {
      const r = await editarGrupoUsuario(openConfirmPreview.idGrupo, openConfirmPreview.body);
      setMsg(r?.mensagem ?? r?.data?.mensagem ?? "Grupo atualizado com sucesso.");
      setOpenSnackbarSucesso(true);
      setOpenConfirmPreview(null);
      await loadCatalogo();
      fecharFormularioGrupo();
    } catch (error) {
      setMsg(error?.response?.data?.mensagem ?? "Erro ao salvar.");
      setOpenSnackbarErro(true);
      setOpenConfirmPreview(null);
    }
  };

  const handleChange = (event) => {
    const { name, value, checked } = event.target;
    let formType = name.startsWith("Edit") ? "edit" : "new";

    if (formType === "edit") {
      setFormEditData((prev) => {
        switch (name) {
          case "EditId":
            return { ...prev, idGrupoUsuario: value };
          case "EditNomeGrupo":
            return { ...prev, nomeGrupo: value.slice(0, 50) };
          case "EditDescricaoResumo":
            return { ...prev, descricaoResumo: value.slice(0, 255) };
          case "EditUsuarios":
            return { ...prev, numUsuarios: value };
          case "EditAtivo":
            return { ...prev, ativo: checked };
          case "EditNivelAssociacao":
            return { ...prev, idNivelAssociacao: value === "" ? null : Number(value) };
          default:
            return prev;
        }
      });
    } else {
      setFormNewData((prev) => {
        switch (name) {
          case "NewId":
            return { ...prev, idGrupoUsuario: value };
          case "NewNomeGrupo":
            return { ...prev, nomeGrupo: value.slice(0, 50) };
          case "NewDescricaoResumo":
            return { ...prev, descricaoResumo: value.slice(0, 255) };
          case "NewUsuarios":
            return { ...prev, numUsuarios: value };
          case "NewAtivo":
            return { ...prev, ativo: checked };
          case "NewNivelAssociacao":
            return { ...prev, idNivelAssociacao: value === "" ? null : Number(value) };
          default:
            return prev;
        }
      });
    }
  };

  const handleCloseSnackbarErro = (_e, reason) => {
    if (reason === "clickaway") return;
    setOpenSnackbarErro(false);
  };
  const handleOpenSnackbarSucesso = () => setOpenSnackbarSucesso(true);
  const handleCloseSnackbarSucesso = (_e, reason) => {
    if (reason === "clickaway") return;
    setOpenSnackbarSucesso(false);
  };

  const handleOpenModalEdit = async (g) => {
    const rawList = g.nome || g.descricao || "";
    const parsedList = parseDescricaoGrupoApi(rawList);
    const row = {
      idGrupoUsuario: Number(g.id),
      nomeGrupo: parsedList.nome,
      descricaoResumo: parsedList.resumo,
      numUsuarios: g.quantidade_usuarios,
      ativo: g.ativo,
      icone: g.icone || "groups",
      cor: g.cor || "blue",
      idNivelAssociacao: g.id_nivel_associacao ?? g.nivel_acesso_associacao ?? null,
    };
    setFormEditData(row);
    try {
      const res = await getGrupoDetalhe(row.idGrupoUsuario);
      const grupo = res?.grupo ?? res?.data?.grupo;
      const permissoes = res?.permissoes ?? grupo?.permissoes ?? [];
      
      // Converter permissões para array de strings (chaves)
      const permissoesChaves = Array.isArray(permissoes)
        ? permissoes.map((p) => (typeof p === "string" ? p : String(p)))
        : [];
      
      setEditFunct(permissoesChaves);
      
      if (grupo && typeof grupo === "object") {
        const p = parseDescricaoGrupoApi(grupo.descricao ?? grupo.nome ?? "");
        setFormEditData((prev) => ({
          ...prev,
          nomeGrupo: p.nome || prev.nomeGrupo,
          descricaoResumo: p.resumo,
          icone: grupo.icone ?? prev.icone,
          cor: grupo.cor ?? prev.cor,
          idNivelAssociacao:
            grupo.idNivelAssociacao ?? grupo.id_nivel_associacao ?? prev.idNivelAssociacao,
          ativo: grupo.ativo !== undefined ? grupo.ativo : prev.ativo,
        }));
      }
      setFormGrupo("edit");
    } catch (error) {
      console.error("Erro ao buscar permissões:", error);
      setFormGrupo("edit");
    }
  };

  const fecharFormularioGrupo = () => {
    setFormGrupo(null);
    setEditFunct();
    setFormEditData();
    setFormNewData();
    setNewFunct();
  };

  const handleOpenModalNewgp = () => {
    setFormNewData({
      ativo: true,
      nomeGrupo: "",
      descricaoResumo: "",
      icone: "groups",
      cor: "blue",
      idNivelAssociacao: null,
    });
    setNewFunct([]);
    setFormGrupo("new");
  };

  const executarDuplicar = async () => {
    if (!openConfirmDup) return;
    try {
      await duplicarGrupoUsuario(openConfirmDup.id);
      setMsg("Grupo duplicado com sucesso.");
      setOpenSnackbarSucesso(true);
      setOpenConfirmDup(null);
      await loadCatalogo();
    } catch (error) {
      setMsg(mensagemErroApi(error));
      setOpenSnackbarErro(true);
    }
  };

  const executarStatus = async () => {
    if (!openConfirmStatus) return;
    try {
      await patchGrupoUsuarioStatus(openConfirmStatus.id, openConfirmStatus.novoAtivo);
      setMsg(openConfirmStatus.novoAtivo ? "Grupo ativado com sucesso." : "Grupo desativado com sucesso.");
      setOpenSnackbarSucesso(true);
      setOpenConfirmStatus(null);
      await loadCatalogo();
    } catch (error) {
      setMsg(mensagemErroApi(error));
      setOpenSnackbarErro(true);
    }
  };

  const nivelSelecionadoId =
    formGrupo === "new" ? formNewData?.idNivelAssociacao : formEditData?.idNivelAssociacao;
  const toggleNivelAssociacaoCard = (idNum) => {
    const cur = nivelSelecionadoId != null && nivelSelecionadoId !== "" ? Number(nivelSelecionadoId) : null;
    const next = cur === idNum ? null : idNum;
    if (formGrupo === "new") {
      setFormNewData((p) => ({ ...p, idNivelAssociacao: next }));
    } else {
      setFormEditData((p) => ({ ...p, idNivelAssociacao: next }));
    }
  };

  const kpiVal = (n) => (loading ? "—" : n ?? 0);
  const formIsNew = formGrupo === "new";
  const formData = formIsNew ? formNewData : formEditData;
  const formPermCount = (formIsNew ? newFunct?.length : editFunct?.length) || 0;
  const totalPermissoesDisponiveis = useMemo(() => {
    const all = [];
    (permissoesArvore || []).forEach((mod) =>
      (mod.subcategorias || []).forEach((sub) =>
        (sub.permissoes || []).forEach((p) => {
          if (p?.chave) all.push(p.chave);
        })
      )
    );
    return new Set(all).size;
  }, [permissoesArvore]);
  const alternarTodasPermissoesGrupo = () => {
    if (permissoesGrupoExpandidas) {
      setRecolherPermissoesGrupoToken((prev) => prev + 1);
      setPermissoesGrupoExpandidas(false);
    } else {
      setExpandirPermissoesGrupoToken((prev) => prev + 1);
      setPermissoesGrupoExpandidas(true);
    }
  };
  const nivelSelecionadoNome = useMemo(() => {
    const id = formData?.idNivelAssociacao;
    if (id == null || id === "") return null;
    const found = niveisOptions.find((n) => Number(n.idNivelAssociacao) === Number(id));
    return found?.nome || null;
  }, [formData?.idNivelAssociacao, niveisOptions]);
  const nivelSelecionadoResumo = nivelSelecionadoNome
    ? formatarResumoNomesSelecionados([nivelSelecionadoNome])
    : "Nenhum nível";
  return (
    <>
      {formGrupo && (
        <form noValidate onSubmit={handleSubmit}>
          <div className={`${listaStyles.pageWrapper} ${listaStyles.formPageWrapper}`}>
            <div className={`${listaStyles.pageRoot} ${listaStyles.formPageRoot}`}>
              <nav className={listaStyles.breadcrumb} aria-label="breadcrumb">
                <RouterLink
                  to="/cadastros/grupos-usuarios"
                  className={listaStyles.crumbLink}
                  onClick={(e) => {
                    e.preventDefault();
                    fecharFormularioGrupo();
                  }}
                >
                  Grupos de Acesso
                </RouterLink>
                <span className={listaStyles.breadcrumbSep}>›</span>
                <span>{formIsNew ? "Novo Grupo" : "Editar Grupo"}</span>
              </nav>

              <main className={listaStyles.formMain}>
                <div className={listaStyles.formTitleRow}>
                  <h1 className={listaStyles.formTitle}>
                    {formIsNew ? (
                      <GroupAddIcon sx={{ color: "#1b3a5f", fontSize: 32 }} />
                    ) : (
                      <EditIcon sx={{ color: "#1b3a5f", fontSize: 32 }} />
                    )}
                    <span>{formIsNew ? "Novo Grupo" : "Editar Grupo"}</span>
                  </h1>
                </div>

            <Grid container spacing={2} alignItems="stretch">
              <Grid item xs={12} md={6}>
                <Stack spacing={2} sx={{ height: "100%" }}>
                <Paper className={listaStyles.formCard} elevation={0} variant="outlined">
                  <div className={listaStyles.formCardHeader}>
                    <WorkOutline sx={{ fontSize: 22 }} />
                    <span>Dados do Grupo</span>
                  </div>
                  <div className={listaStyles.formCardBody}>

                  {formGrupo === "new" ? (
                    <>
                      <TextField
                        name="NewNomeGrupo"
                        value={formNewData?.nomeGrupo || ""}
                        size="small"
                        label="NOME DO GRUPO"
                        placeholder="Ex: Financeiro, Fiscal, Operações..."
                        fullWidth
                        required
                        onChange={handleChange}
                        sx={{ mb: 2 }}
                        inputProps={{ maxLength: 50 }}
                      />
                      <TextField
                        name="NewDescricaoResumo"
                        value={formNewData?.descricaoResumo || ""}
                        size="small"
                        label="DESCRIÇÃO"
                        placeholder="Descreva as responsabilidades e funções deste grupo..."
                        fullWidth
                        multiline
                        minRows={3}
                        onChange={handleChange}
                        sx={{ mb: 0.5 }}
                        inputProps={{ maxLength: 255 }}
                      />
                      <Typography variant="caption" color="text.secondary" display="block" sx={{ mb: 2 }}>
                        Máximo de 255 caracteres
                      </Typography>
                      <Grid container spacing={3}>
                        <Grid item xs={12} md={6}>
                          <Typography variant="caption" sx={{ fontWeight: 500, color: "#5f6368", display: "block", mb: 1, textTransform: "uppercase", letterSpacing: 0.5, fontSize: "12px" }}>
                            ÍCONE *
                          </Typography>
                          <IconSelector
                            value={formNewData?.icone || "groups"}
                            onChange={(icone) => setFormNewData((prev) => ({ ...prev, icone }))}
                          />
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <Typography variant="caption" sx={{ fontWeight: 500, color: "#5f6368", display: "block", mb: 1, textTransform: "uppercase", letterSpacing: 0.5, fontSize: "12px" }}>
                            COR *
                          </Typography>
                          <ColorSelector value={formNewData?.cor || "blue"} onChange={(cor) => setFormNewData((prev) => ({ ...prev, cor }))} />
                        </Grid>
                      </Grid>
                      <Box sx={{ display: "flex", alignItems: "center", gap: 1, mt: 2, mb: 1 }}>
                        <Typography variant="body2" color="text.secondary">
                          Grupo Ativo
                        </Typography>
                        <Switch name="NewAtivo" checked={formNewData?.ativo !== false} onChange={handleChange} color="success" />
                      </Box>
                      <Box sx={{ mt: 2 }}>
                        <CardPreview
                          icon={formNewData?.icone || "groups"}
                          color={formNewData?.cor || "blue"}
                          name={formNewData?.nomeGrupo?.trim() || "Nome do Grupo"}
                          description={formNewData?.descricaoResumo?.trim() || "Descrição do grupo"}
                          numPermissions={newFunct?.length || 0}
                          ativo={formNewData?.ativo !== false}
                          previewLabel="PRÉ-VISUALIZAÇÃO"
                        />
                      </Box>
                    </>
                  ) : (
                    <>
                      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2, alignItems: "center", mb: 2 }}>
                        <TextField name="EditId" value={formEditData?.idGrupoUsuario || ""} disabled size="small" label="ID" sx={{ width: "5rem" }} />
                        <TextField name="EditUsuarios" value={formEditData?.numUsuarios ?? 0} size="small" label="USUÁRIOS" sx={{ width: "6rem" }} disabled />
                      </Box>
                      <TextField
                        name="EditNomeGrupo"
                        value={formEditData?.nomeGrupo || ""}
                        size="small"
                        label="NOME DO GRUPO"
                        placeholder="Ex: Financeiro, Fiscal, Operações..."
                        fullWidth
                        required
                        onChange={handleChange}
                        sx={{ mb: 2 }}
                        inputProps={{ maxLength: 50 }}
                      />
                      <TextField
                        name="EditDescricaoResumo"
                        value={formEditData?.descricaoResumo || ""}
                        size="small"
                        label="DESCRIÇÃO"
                        placeholder="Descreva as responsabilidades e funções deste grupo..."
                        fullWidth
                        multiline
                        minRows={3}
                        onChange={handleChange}
                        sx={{ mb: 0.5 }}
                        inputProps={{ maxLength: 255 }}
                      />
                      <Typography variant="caption" color="text.secondary" display="block" sx={{ mb: 2 }}>
                        Máximo de 255 caracteres
                      </Typography>
                      <Grid container spacing={3}>
                        <Grid item xs={12} md={6}>
                          <Typography variant="caption" sx={{ fontWeight: 500, color: "#5f6368", display: "block", mb: 1, textTransform: "uppercase", letterSpacing: 0.5, fontSize: "12px" }}>
                            ÍCONE *
                          </Typography>
                          <IconSelector
                            value={formEditData?.icone || "groups"}
                            onChange={(icone) => setFormEditData((prev) => ({ ...prev, icone }))}
                          />
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <Typography variant="caption" sx={{ fontWeight: 500, color: "#5f6368", display: "block", mb: 1, textTransform: "uppercase", letterSpacing: 0.5, fontSize: "12px" }}>
                            COR *
                          </Typography>
                          <ColorSelector value={formEditData?.cor || "blue"} onChange={(cor) => setFormEditData((prev) => ({ ...prev, cor }))} />
                        </Grid>
                      </Grid>
                      <Box sx={{ mt: 2 }}>
                        <CardPreview
                          icon={formEditData?.icone || "groups"}
                          color={formEditData?.cor || "blue"}
                          name={formEditData?.nomeGrupo?.trim() || "Nome do Grupo"}
                          description={formEditData?.descricaoResumo?.trim() || "Descrição do grupo"}
                          numPermissions={editFunct?.length || 0}
                          ativo={formEditData?.ativo === "Sim" || formEditData?.ativo === true}
                          previewLabel="PRÉ-VISUALIZAÇÃO"
                        />
                      </Box>
                    </>
                  )}
                  </div>
                </Paper>

                {podeGerenciarNiveisAssociacao && (
                <Paper className={listaStyles.formCard} elevation={0} variant="outlined">
                  <div className={listaStyles.formCardHeader}>
                    <AdminPanelSettings sx={{ fontSize: 22 }} />
                    <span>Nível de Acesso para Associação</span>
                    <span className={listaStyles.formHeaderBadge}>
                      {nivelSelecionadoNome || "Nenhum selecionado"}
                    </span>
                  </div>
                  <div className={listaStyles.formCardBody}>
                    <Typography variant="body2" color="#80868b" sx={{ mb: 2, fontSize: "13px" }}>
                      Define quem pode associar usuários a este grupo. Apenas usuários com o nível selecionado (ou superior) poderão atribuir este
                      grupo a outros usuários.
                    </Typography>
                    <Grid container spacing={2}>
                    {niveisOptions.map((n, idx) => {
                      const IconComp = NIVEL_CARD_ICONS[idx % NIVEL_CARD_ICONS.length];
                      const nid = Number(n.idNivelAssociacao);
                      const selected =
                        nivelSelecionadoId != null &&
                        nivelSelecionadoId !== "" &&
                        Number(nivelSelecionadoId) === nid;
                      return (
                        <Grid item xs={12} sm={6} key={n.chave}>
                          <Paper
                            variant="outlined"
                            onClick={() => toggleNivelAssociacaoCard(nid)}
                            sx={{
                              p: 2,
                              height: "100%",
                              cursor: "pointer",
                              border: selected ? "2px solid #1976d2" : "1px solid",
                              borderColor: selected ? "#1976d2" : "#e8e8e8",
                              bgcolor: selected ? "#f5f9ff" : "#fff",
                              borderRadius: 2,
                              transition: "border-color 0.2s, background-color 0.2s",
                              "&:hover": { borderColor: "#1976d2", bgcolor: "#fafafa" },
                            }}
                          >
                            <Box sx={{ display: "flex", gap: 1.5, alignItems: "flex-start" }}>
                              <Box sx={{ color: "#18316e", display: "flex", pt: 0.25 }}>
                                <IconComp sx={{ fontSize: 28 }} />
                              </Box>
                              <Box sx={{ minWidth: 0 }}>
                                <Typography fontWeight={600} color="text.primary" sx={{ lineHeight: 1.3 }}>
                                  {n.nome}
                                </Typography>
                                <Typography variant="body2" color="text.secondary" sx={{ mt: 0.75, fontSize: "0.8125rem", lineHeight: 1.4 }}>
                                  {n.descricao || "—"}
                                </Typography>
                              </Box>
                            </Box>
                          </Paper>
                        </Grid>
                      );
                    })}
                    </Grid>
                  </div>
                </Paper>
                )}
                </Stack>
              </Grid>

              <Grid item xs={12} md={6}>
                <Paper
                  variant="outlined"
                  className={listaStyles.permissionsCard}
                >
                  <div className={listaStyles.permissionsHeader}>
                    <div className={listaStyles.permissionsTitle}>
                      <PermissoesGrupoShieldIcon boxSize={28} iconSize={18} />
                      <span>Permissões do Grupo</span>
                    </div>
                    <div className={listaStyles.permissionsHeaderRight}>
                      <span className={listaStyles.permissionsHeaderBadge}>
                        {formPermCount} de {totalPermissoesDisponiveis}
                      </span>
                    </div>
                  </div>
                  <div className={listaStyles.permissionsTopbar}>
                    <button
                      type="button"
                      className={listaStyles.outlineMiniBtn}
                      onClick={alternarTodasPermissoesGrupo}
                      disabled={permissoesArvore.length === 0}
                    >
                      {permissoesGrupoExpandidas ? (
                        <ExpandLess className={listaStyles.outlineMiniBtnIcon} aria-hidden />
                      ) : (
                        <ExpandMore className={listaStyles.outlineMiniBtnIcon} aria-hidden />
                      )}
                      {permissoesGrupoExpandidas ? "Recolher todas" : "Expandir todas"}
                    </button>
                    <div className={listaStyles.permissionsTopbarRight}>
                      <span className={listaStyles.permissionsSelectedText}>
                        {formPermCount} {formPermCount === 1 ? "permissão selecionada" : "permissões selecionadas"}
                      </span>
                      <button
                        type="button"
                        className={listaStyles.outlineMiniBtn}
                        onClick={() => (formIsNew ? setNewFunct([]) : setEditFunct([]))}
                      >
                        <FilterListIcon className={listaStyles.outlineMiniBtnIcon} aria-hidden />
                        Limpar
                      </button>
                    </div>
                  </div>
                  <Box sx={{ flex: 1, minHeight: 0, display: "flex", flexDirection: "column", overflow: "visible" }}>
                    <PermissionsTree
                      data={permissoesArvore}
                      selected={formGrupo === "new" ? newFunct || [] : editFunct || []}
                      onChange={formGrupo === "new" ? setNewFunct : setEditFunct}
                      showCounters
                      panelLayout
                      expandAllToken={expandirPermissoesGrupoToken}
                      collapseAllToken={recolherPermissoesGrupoToken}
                    />
                  </Box>
                </Paper>
              </Grid>
            </Grid>

            {/* Rodapé alinhado à tela Cadastrar/Editar Usuário: chips + Cancelar / Salvar */}
            <Box
              sx={{
                position: "sticky",
                bottom: 0,
                left: 0,
                right: 0,
                display: "flex",
                flexWrap: "wrap",
                alignItems: "center",
                justifyContent: "space-between",
                gap: 2,
                mt: 3,
                py: 2,
                px: 2,
                bgcolor: "#fff",
                borderTop: "1px solid",
                borderColor: "#e8e8e8",
                borderRadius: "12px",
                boxShadow: "0 -2px 8px rgba(0,0,0,0.06)",
              }}
            >
              <Box sx={{ display: "flex", flexWrap: "wrap", alignItems: "center", gap: 2 }}>
                <Chip
                  icon={<Tune sx={{ fontSize: 18 }} />}
                  label={nivelSelecionadoResumo}
                  size="small"
                  sx={{ bgcolor: "#e8f5e9", color: "#2e7d32" }}
                />
                <Chip
                  icon={<Lock sx={{ fontSize: 18 }} />}
                  label={`${formPermCount} permissão(ões) na seleção`}
                  size="small"
                  sx={{ bgcolor: "#fff3e0", color: "#e65100" }}
                />
              </Box>
              <Box sx={{ display: "flex", gap: 1 }}>
                <WhiteButton textValue="Cancelar" clickFunction={fecharFormularioGrupo} type="button" />
                {!formIsNew && (podeAlterarStatus || podeExcluir) && formEditData?.ativo !== false ? (
                  <Button
                    variant="outlined"
                    color="error"
                    type="button"
                    onClick={() => setOpenConfirmStatus({
                      id: formEditData?.idGrupoUsuario,
                      novoAtivo: false,
                      qtdUsuarios: formEditData?.numUsuarios ?? 0,
                    })}
                  >
                    Desativar
                  </Button>
                ) : null}
                <BlueButton
                  textValue={formIsNew ? "Salvar" : "Salvar Alterações"}
                  type="submit"
                />
              </Box>
            </Box>
              </main>
            </div>
          </div>
        </form>
      )}

      <ConfirmDialog
        open={Boolean(openConfirmDup)}
        onClose={() => setOpenConfirmDup(null)}
        onClickSim={executarDuplicar}
        title="Duplicar grupo"
        text="Será criada uma cópia inativa com as mesmas permissões. Confirmar?"
        confirmLabel="Confirmar"
      />

      <ConfirmDialog
        open={Boolean(openConfirmStatus)}
        onClose={() => setOpenConfirmStatus(null)}
        onClickSim={executarStatus}
        title={openConfirmStatus?.novoAtivo ? "Ativar grupo" : "Desativar grupo"}
        text={
          !openConfirmStatus?.novoAtivo && openConfirmStatus?.qtdUsuarios > 0
            ? `${openConfirmStatus.qtdUsuarios} usuário(s) vinculado(s) perderão permissões herdadas deste grupo enquanto ele estiver inativo.\n\nDeseja continuar?`
            : "Deseja continuar?"
        }
        confirmLabel="Confirmar"
        confirmVariant={openConfirmStatus?.novoAtivo ? "primary" : "error"}
      />

      <ConfirmDialog
        open={Boolean(openConfirmDelete)}
        onClose={() => setOpenConfirmDelete(null)}
        onClickSim={executarExcluirGrupo}
        title="Excluir grupo"
        text="Essa ação não poderá ser desfeita. Confirmar exclusão do grupo?"
        confirmLabel="Excluir"
        confirmVariant="error"
      />

      <ConfirmDialog
        open={Boolean(openConfirmPreview)}
        onClose={() => setOpenConfirmPreview(null)}
        onClickSim={confirmarSalvarComImpacto}
        title="Confirmar alteração de permissões"
        text={[
          `${openConfirmPreview?.preview?.usuariosAfetados ?? 0} usuário(s) serão afetados por esta alteração.`,
          Array.isArray(openConfirmPreview?.preview?.permissoesRemovidas) && openConfirmPreview.preview.permissoesRemovidas.length > 0
            ? `Permissões removidas: ${openConfirmPreview.preview.permissoesRemovidas.length}`
            : null,
        ].filter(Boolean).join("\n\n")}
        confirmLabel="Confirmar e salvar"
        confirmVariant="error"
      />

      {!formGrupo && (
        <Paper elevation={0} sx={{ margin: "0 2rem", borderRadius: "12px", bgcolor: "#f5f7fa", boxShadow: "0 1px 4px rgba(0,0,0,0.10)", overflow: "hidden" }}>
          <Box sx={{ margin: "16px 24px", borderRadius: "12px", border: "1px solid #e0e0e0", bgcolor: "#ffffff", boxShadow: "0 2px 8px rgba(0,0,0,0.07)", overflow: "hidden" }}>
            <Box sx={{ display: "flex", flexWrap: "wrap", gap: "10px", justifyContent: "space-between", alignItems: "center", padding: "16px 24px", bgcolor: "#ffffff", borderBottom: "1px solid #e0e0e0" }}>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                <GroupsIcon sx={{ fontSize: 32, color: "#1b3a5f" }} />
                <Typography sx={{ fontSize: "1.625rem", fontWeight: 600, color: "#1b3a5f" }}>Grupos de Acesso</Typography>
              </Box>
              {podeCriar ? (
                <Button
                  variant="contained"
                  size="small"
                  startIcon={<Add />}
                  onClick={handleOpenModalNewgp}
                  sx={{ borderRadius: "8px", textTransform: "none", fontWeight: 600, bgcolor: "primary.main", minHeight: 40, whiteSpace: "nowrap", px: 2, boxShadow: "none", "&:hover": { boxShadow: "none" } }}
                >
                  Novo Grupo
                </Button>
              ) : null}
            </Box>
            <Box sx={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: 2, bgcolor: "#fafafa", padding: "20px 24px", "@media (max-width: 1024px)": { gridTemplateColumns: "repeat(2, 1fr)" }, "@media (max-width: 768px)": { gridTemplateColumns: "1fr" } }}>
              {[
                { icon: <GroupsIcon sx={{ fontSize: 24 }} />, bg: "#e3f2fd", color: "#1565c0", value: kpiVal(stats?.total_grupos), label: "Total de Grupos" },
                { icon: <CheckCircleIcon sx={{ fontSize: 24 }} />, bg: "#e8f5e9", color: "#2e7d32", value: kpiVal(stats?.grupos_ativos), label: "Grupos Ativos" },
                { icon: <PeopleIcon sx={{ fontSize: 24 }} />, bg: "#ede7f6", color: "#673ab7", value: kpiVal(stats?.total_usuarios_em_grupos), label: "Usuários em Grupos" },
                { icon: <SecurityIcon sx={{ fontSize: 24 }} />, bg: "#fff3e0", color: "#e65100", value: kpiVal(stats?.total_permissoes_disponiveis), label: "Permissões Disponíveis" },
              ].map(({ icon, bg, color, value, label }) => (
                <Paper key={label} elevation={0} sx={{ py: 2, px: 2.5, display: "flex", alignItems: "center", gap: 2, borderRadius: "8px", border: "1px solid #e8ecf0", bgcolor: "#ffffff", boxShadow: "none", height: "100%", minHeight: 80, transition: "box-shadow 0.2s ease, border-color 0.2s ease", "&:hover": { borderColor: "#c5cdd8", boxShadow: "0 2px 8px rgba(0,0,0,0.08)" } }}>
                  <Box sx={{ width: 44, height: 44, borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", bgcolor: bg, color, flexShrink: 0 }}>
                    {icon}
                  </Box>
                  <Box>
                    <Typography sx={{ fontSize: "1.75rem", fontWeight: 700, lineHeight: 1, color: "#1b3a5f" }}>{value}</Typography>
                    <Typography sx={{ color: "#757575", fontSize: "0.75rem", fontWeight: 500, textTransform: "uppercase", letterSpacing: "0.5px", mt: 0.25 }}>{label}</Typography>
                  </Box>
                </Paper>
              ))}
            </Box>
            <Box sx={{ height: 1, bgcolor: "#e0e0e0" }} />
            <Box sx={{ bgcolor: "#ffffff" }}>

                  <div className={listaStyles.groupsGrid}>
                    {loading ? (
                      <Box
                        sx={{
                          gridColumn: "1 / -1",
                          display: "flex",
                          justifyContent: "center",
                          py: 8,
                        }}
                      >
                        <CircularProgress sx={{ color: "#1a73e8" }} />
                      </Box>
                    ) : grupos.length === 0 ? (
                      <div className={listaStyles.emptyState}>
                        <SearchOff sx={{ fontSize: 64, color: "#dadce0", mb: 2, display: "block", mx: "auto" }} />
                        <h3>Nenhum grupo encontrado</h3>
                        <p>Tente ajustar os filtros ou crie um novo grupo.</p>
                      </div>
                    ) : (
                      grupos.map((g) => {
                        const cor = (g.cor || "blue").toLowerCase();
                        const bg = COR_ICON_BG[cor] || COR_ICON_BG.blue;
                        const fg = COR_ICON_FG[cor] || COR_ICON_FG.blue;
                        const parsed = parseDescricaoGrupoApi(String(g.descricao || ""));
                        const tituloCard = (parsed.nome || g.nome || "").trim() || "Grupo";
                        const idNivelAssociacao =
                          g?.id_nivel_associacao ?? g?.nivel_acesso_associacao ?? g?.idNivelAssociacao ?? null;
                        const nivelAssociacaoNome =
                          idNivelAssociacao != null
                            ? niveisOptions.find((n) => Number(n.idNivelAssociacao) === Number(idNivelAssociacao))
                                ?.nome
                            : null;
                        const nivelTag = (nivelAssociacaoNome || g.nivel_acesso_nome || "").trim();
                        let descricaoCard = (parsed.resumo || "").trim();
                        if (!descricaoCard && nivelTag) descricaoCard = String(nivelTag);
                        if (!descricaoCard) descricaoCard = "Acesso conforme permissões do grupo";
                        const ativo = Boolean(g.ativo);
                        return (
                          <div
                            key={g.id}
                            role={podeEditar ? "button" : undefined}
                            tabIndex={podeEditar ? 0 : undefined}
                            className={`${listaStyles.groupCard} ${!ativo ? listaStyles.groupCardInactive : ""}`}
                            style={{ cursor: podeEditar ? "pointer" : "default" }}
                            onClick={() => podeEditar && handleOpenModalEdit(g)}
                            onKeyDown={(e) => {
                              if ((e.key === "Enter" || e.key === " ") && podeEditar) {
                                e.preventDefault();
                                handleOpenModalEdit(g);
                              }
                            }}
                          >
                            <div className={listaStyles.groupStatus}>
                              <span
                                className={`${listaStyles.statusBadge} ${
                                  ativo ? listaStyles.statusBadgeActive : listaStyles.statusBadgeInactive
                                }`}
                              >
                                {ativo ? "Ativo" : "Inativo"}
                              </span>
                            </div>
                            <div className={listaStyles.groupHeader}>
                              <div className={listaStyles.groupIcon} style={{ background: bg, color: fg }}>
                                <GrupoListAvatarIcon iconKey={g.icone} />
                              </div>
                              <div style={{ minWidth: 0, flex: 1 }}>
                                <div className={listaStyles.groupName}>{tituloCard}</div>
                                <div className={listaStyles.groupDesc}>{descricaoCard}</div>
                              </div>
                            </div>
                            <div className={listaStyles.groupStats}>
                              <div className={listaStyles.groupStat}>
                                <PeopleIcon sx={{ color: "#80868b" }} />
                                <span>
                                  <strong>{typeof g.quantidade_usuarios === "number" ? g.quantidade_usuarios : 0}</strong>{" "}
                                  usuários
                                </span>
                              </div>
                              <div className={listaStyles.groupStat}>
                                <SecurityIcon sx={{ color: "#80868b" }} />
                                <span>
                                  <strong>{g.quantidade_permissoes ?? 0}</strong> permissões
                                </span>
                              </div>
                            </div>
                            {nivelTag ? (
                              <div className={listaStyles.groupStatsNivel}>
                                <span className={listaStyles.accessLevelTag}>
                                  <AdminPanelSettings sx={{ fontSize: 14 }} />
                                  {nivelTag}
                                </span>
                              </div>
                            ) : null}
                            <div
                              className={listaStyles.groupActions}
                              onClick={(e) => e.stopPropagation()}
                              onKeyDown={(e) => e.stopPropagation()}
                              role="presentation"
                            >
                              {podeEditar && (
                                <Button
                                  size="small"
                                  variant="outlined"
                                  startIcon={<EditIcon sx={{ fontSize: 16 }} />}
                                  onClick={() => handleOpenModalEdit(g)}
                                  sx={{
                                    textTransform: "none",
                                    fontSize: 12,
                                    py: 0.75,
                                    px: 1.5,
                                    borderColor: "#dadce0",
                                    color: "#5f6368",
                                    "&:hover": { borderColor: "#bdc1c6", bgcolor: "#f8f9fa" },
                                  }}
                                >
                                  Editar
                                </Button>
                              )}
                              {podeDuplicar && (
                                <Button
                                  size="small"
                                  variant="outlined"
                                  startIcon={<ContentCopyIcon sx={{ fontSize: 16 }} />}
                                  onClick={() => setOpenConfirmDup({ id: Number(g.id) })}
                                  sx={{
                                    textTransform: "none",
                                    fontSize: 12,
                                    py: 0.75,
                                    px: 1.5,
                                    borderColor: "#dadce0",
                                    color: "#5f6368",
                                    "&:hover": { borderColor: "#bdc1c6", bgcolor: "#f8f9fa" },
                                  }}
                                >
                                  Duplicar
                                </Button>
                              )}
                              {podeAlterarStatus &&
                                (ativo ? (
                                  <Button
                                    size="small"
                                    variant="outlined"
                                    startIcon={<BlockIcon sx={{ fontSize: 16 }} />}
                                    onClick={() =>
                                      setOpenConfirmStatus({
                                        id: Number(g.id),
                                        novoAtivo: false,
                                        qtdUsuarios: g.quantidade_usuarios,
                                      })
                                    }
                                    sx={{
                                      textTransform: "none",
                                      fontSize: 12,
                                      py: 0.75,
                                      px: 1.5,
                                      borderColor: "#dadce0",
                                      color: "#5f6368",
                                      "&:hover": { borderColor: "#bdc1c6", bgcolor: "#f8f9fa" },
                                    }}
                                  >
                                    Desativar
                                  </Button>
                                ) : (
                                  <Button
                                    size="small"
                                    variant="outlined"
                                    startIcon={<CheckCircleIcon sx={{ fontSize: 16 }} />}
                                    onClick={() =>
                                      setOpenConfirmStatus({
                                        id: Number(g.id),
                                        novoAtivo: true,
                                        qtdUsuarios: g.quantidade_usuarios,
                                      })
                                    }
                                    sx={{
                                      textTransform: "none",
                                      fontSize: 12,
                                      py: 0.75,
                                      px: 1.5,
                                      borderColor: "#34a853",
                                      color: "#34a853",
                                      "&:hover": { borderColor: "#2d9348", bgcolor: "#e6f4ea" },
                                    }}
                                  >
                                    Ativar
                                  </Button>
                                ))}
                            </div>
                          </div>
                        );
                      })
                    )}
                  </div>

                  <Pagination
                    paginationKey="grupos-acesso"
                    data={grupos}
                    serverSideTotal={totalItems || totalPages * perPage}
                    serverSidePage={page}
                    serverSideRowsPerPage={perPage}
                    onServerPageChange={(p) => setPage(p)}
                    onServerRowsPerPageChange={() => {}}
                  />
            </Box>
          </Box>
        </Paper>
      )}

      <MensagemSucesso open={openSnackbarSucesso} handleClose={handleCloseSnackbarSucesso} msg={msg} />
      <MensagemErro open={openSnackbarErro} handleClose={handleCloseSnackbarErro} msg={msg} />
    </>
  );
};

export default GruposUsuarios;

/*
  (trecho removido/reatribuído acima)
*/
